import { vetor } from '../geometria/vetor3'
import { deslocamentoNoPonto, type EstadoDeformacaoVeiculo } from './campoDeformacao'
import type { FaixaLongitudinal, PerfilVeiculo } from './perfilVeiculo'

/** Largura do volume didático da zona de absorção: da longarina à longarina. */
export const larguraDaZonaDeAbsorcao = (perfil: PerfilVeiculo): number => perfil.largura - 0.28

/** Pontos ao longo da largura em que a face da zona é comparada à chapa. */
const AMOSTRAS_LARGURA = 9

/**
 * Faixa da zona de absorção "gasta" na colisão: a face externa recua junto com
 * o para-choque, e o volume que sobra mostra quanto da absorção foi consumido.
 *
 * A face é plana e a chapa amassada não: ela recua até o ponto MAIS amassado ao
 * longo da largura. Medida num ponto só, sobrava caixa à frente da chapa onde o
 * amassado era mais fundo — e a zona aparecia entrando no outro veículo.
 */
export function faixaDaZonaDeAbsorcao(
  estado: EstadoDeformacaoVeiculo | null | undefined,
  perfil: PerfilVeiculo,
  faixa: FaixaLongitudinal,
): FaixaLongitudinal {
  const dianteira = faixa.zDianteiro >= perfil.frenteZ - 1e-6
  const y = (perfil.pisoY + perfil.capoY) / 2
  const zFace = dianteira ? perfil.frenteZ : perfil.traseiraZ
  const meia = larguraDaZonaDeAbsorcao(perfil) / 2
  let face = dianteira ? faixa.zDianteiro : faixa.zTraseiro
  for (let i = 0; i < AMOSTRAS_LARGURA; i += 1) {
    const x = -meia + (2 * meia * i) / (AMOSTRAS_LARGURA - 1)
    const chapa = zFace + deslocamentoNoPonto(estado, perfil, vetor(x, y, zFace), 'paraChoque').z
    face = dianteira ? Math.min(face, chapa) : Math.max(face, chapa)
  }
  return dianteira
    ? { zDianteiro: face, zTraseiro: faixa.zTraseiro }
    : { zDianteiro: faixa.zDianteiro, zTraseiro: face }
}
